<template>
  <v-expand-transition>
    <v-card
      width="320"
      style="border:1px rgba(0,0,0,0.3) solid;"
    >
      <v-card-text>
        <v-card
          v-for="note in notes"
          :key="note.id"
          style="margin-bottom:10px;"
        >
          <v-toolbar
            dense
            flat
            color="blue"
            dark
          >
            {{ note.username }} @ {{ formatDate(note.created_at) }}
          </v-toolbar>
          <v-card-text>
            {{ note.text }}
          </v-card-text>
        </v-card>
        <v-textarea
          v-model="newNoteText"
          hide-details
          box
          class="form-control"
          label="Note"
        ></v-textarea>
        <v-btn
          class="btn btn-primary"
          @click="saveNote"
        >
          Save Note
        </v-btn>
        <TryAgain
          v-if="failedNote"
          :message="'Save Note'"
          @try="saveNote"
        />
      </v-card-text>
    </v-card>
  </v-expand-transition>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import api from '@/api'
import TryAgain from './TryAgain'

export default {
  name: 'AnswerReview',
  props: [ 'userFormId', 'questionId', 'fieldTypeId', 'listId'],
  components: {
    TryAgain
  },
  data () {
    return {
      newNoteText: '',
      position: 'right',
      failed: false,
      failedNote: false,
      menu: false,
      notes: []
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    ...mapActions('userform', [ 'updateAnswerStatus' ]),
    ...mapMutations('userform', [ 'setSaving', 'unsetSaving' ]),
    formatDate (date) {
      return moment(date).fromNow()
    },
    fetch () {
      api.userform.userForm.getNotes(
        this.userFormId, this.questionId, this.fieldTypeId, this.listId ? this.listId.id : null
      ).then(notes => {
        try {
          this.notes = notes
          const parentBounds = this.$el.parentNode.getBoundingClientRect()
          this.position = (parentBounds.x + parentBounds.width > 500)
            ? 'right' : 'left'
        } catch (error) {
          return error
        }
      })

    },
    saveNote () {
      this.failedNote = false
      const saveAction = api.userform.userForm.addNote(
        this.userFormId, this.questionId, this.fieldTypeId, this.listId ? this.listId.id : null, this.listId ? this.listId.uuid : null,
        this.newNoteText
      ).then(note => {
        this.notes.push(note)
        this.newNoteText = ''
        this.unsetSaving(saveAction)
        if (this.listId && this.listId.uuid && note.list_id) {
          this.$emit('update:listId', {id: note.list_id, uuid: this.listId.uuid})
        }
      }).catch(() => {
        this.failedNote = true
        this.unsetSaving(saveAction)
      })
      this.setSaving(saveAction)
    }
  }
}
</script>

<style>
.review-popover {
  position: relative;
}
.review-popover .review-content {
  position: absolute;
  border: 1px solid #BFBFBF;
  background-color: #FFFFFF;
  left: 0;
  width: 500px;
  padding: 5px;
  transform: translate(0, 10px);
  z-index: 100;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}
.review-popover .review-content[x-position=right] {
  right: 0;
  left: auto;
}
.review-popover .review-content:before {
  position: absolute;
  content: '';
  left: calc(50%);
  top: -20px;
  border-style: solid;
  border-width: 10px 10px 10px 10px;
  border-color: transparent transparent #BFBFBF transparent;
}
.review-popover .review-content[x-position=right]:before {
  left: auto;
  right: 0;
}
</style>
